import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FileItem, FileUploader } from 'ng2-file-upload';
import { PercentagePipe } from '../../pipes/percentage/percentage.pipe';

@Component({
    selector: 'ca-upload-progress-container',
    templateUrl: './upload-progress-container.component.html',
    styleUrls: ['./upload-progress-container.component.scss'],
})
export class UploadProgressContainerComponent {
    @Input() initialUploaderQueueLength: number = 0;
    @Input() initialValueOfFilesToBeUploaded: number = 0;
    @Input() uploader: FileUploader | undefined = undefined;
    @Input() placement: 'left' | 'right' = 'right';
    @Input() numberOfCziFilesBeingConverted: number = 0;
    @Input() numberOfFilesBeingValidated: number = 0;

    @Output() cancelAllFileUploads = new EventEmitter<void>();
    @Output() cancelFileUpload = new EventEmitter<FileItem>();

    areUploadDetailsVisible = false;
    overallUploadProgress: string = '0%';

    constructor(private percentagePipe: PercentagePipe) {}

    onProgressChanged(): void {
        // setTimeout to avoid expression has changed after it was checked exception
        // (progress of the upload item is changed outside of the change detection cycle)
        setTimeout((): void => {
            this.getOverallUploadProgress();
        });
    }
    getOverallUploadProgress(): string {
        const uploaderQueueLength = this.uploader?.queue.length || 0;

        // has to be calculated because this.uploader.progress looks into single file progress
        if (this.initialUploaderQueueLength === 0) {
            return '0%';
        } else if (uploaderQueueLength > 0) {
            // every file gets a part of 100%
            const percentagePart = this.initialValueOfFilesToBeUploaded ? 100 / this.initialValueOfFilesToBeUploaded : 100 / this.initialUploaderQueueLength;

            const percentagesOfRemainingFiles =
                this.uploader?.queue.reduce((accumulator, f): number => {
                    return f.progress < 100 ? accumulator + (percentagePart * f.progress) / 100 : accumulator + 0;
                }, 0) || 0;

            // every time file has finished uploading it is removed from this.uploader.queue,
            // but we need to calculate with initial length to get correct overall progress
            const percentagesOfFinishedFiles = this.initialValueOfFilesToBeUploaded
                ? percentagePart * (this.initialValueOfFilesToBeUploaded - uploaderQueueLength)
                : percentagePart * (this.initialUploaderQueueLength - uploaderQueueLength);
            return this.percentagePipe.transform(percentagesOfFinishedFiles + percentagesOfRemainingFiles);
        }
        return '100%';
    }
}
